import { createSSRApp } from 'vue';
import sliceNameMixin from '@core/mixins/slice-name.js';
import type { SSRContext as EngineSSRContext } from '@model/ssr/context';
import App from './root.vue';
import { StoreFactory } from './store/store-factory';
import { RouterFactory } from './views/router-factory';

export function createApp(context?: EngineSSRContext | Record<string, any>) {
    const app = createSSRApp(App);

    app.config.globalProperties.$app = app;
    app.config.throwUnhandledErrorInProduction = true;

    // See: https://pmc.acronis.work/browse/WEB-48408
    app.mixin(sliceNameMixin);

    if (context && 'req' in context && 'res' in context) {
        app.config.globalProperties.$ssrContext = context;
        const store = StoreFactory(context);
        const router = RouterFactory(context, 'ssr');
        app.use(store);
        app.use(router);
        return { app, store, router };
    }

    const store = StoreFactory(context ?? {});
    const router = RouterFactory(context ?? {}, 'browser');
    app.use(store);
    app.use(router);
    return { app, store, router };
}
